import React from "react";

const CardTeam = (props) => {
  const { title, name, description, icone } = props.member;
  return (
    <div className="flex flex-col items-center px-9 py-9  bg-white rounded-3xl shadow-lg max-md:px-5 max-md:mt-10">
      <img
        loading="lazy"
        src={icone}
        className="max-w-full rounded-full w-[121px]"
        alt="member"
      />
      <div className="mt-3.5 text-xl text-center">{title}</div>
      <div className="mt-2 text-base text-center whitespace-nowrap">{name}</div>
      <div className="mt-8 text-sm text-gray-600 md:w-[272px] w-[222px]">
        {description}
      </div>
    </div>
  );
};

export default CardTeam;
